/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seller_Dashboard_Stat_RevenueInputs */

const en_seller_dashboard_stat_revenue = /** @type {(inputs: Seller_Dashboard_Stat_RevenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revenue`)
};

const es_seller_dashboard_stat_revenue = /** @type {(inputs: Seller_Dashboard_Stat_RevenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingresos`)
};

const fr_seller_dashboard_stat_revenue = /** @type {(inputs: Seller_Dashboard_Stat_RevenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revenus`)
};

const de_seller_dashboard_stat_revenue = /** @type {(inputs: Seller_Dashboard_Stat_RevenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Umsatz`)
};

const ja_seller_dashboard_stat_revenue = /** @type {(inputs: Seller_Dashboard_Stat_RevenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`収益`)
};

const zh_seller_dashboard_stat_revenue = /** @type {(inputs: Seller_Dashboard_Stat_RevenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`总收入`)
};

const ar_seller_dashboard_stat_revenue = /** @type {(inputs: Seller_Dashboard_Stat_RevenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الإيرادات`)
};

const id_seller_dashboard_stat_revenue = /** @type {(inputs: Seller_Dashboard_Stat_RevenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pendapatan`)
};

const it_seller_dashboard_stat_revenue = /** @type {(inputs: Seller_Dashboard_Stat_RevenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrate`)
};

const ru_seller_dashboard_stat_revenue = /** @type {(inputs: Seller_Dashboard_Stat_RevenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Доход`)
};

const pt_seller_dashboard_stat_revenue = /** @type {(inputs: Seller_Dashboard_Stat_RevenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Receita`)
};

const ko_seller_dashboard_stat_revenue = /** @type {(inputs: Seller_Dashboard_Stat_RevenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`수익`)
};

/**
* | output |
* | --- |
* | "Revenue" |
*
* @param {Seller_Dashboard_Stat_RevenueInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const seller_dashboard_stat_revenue = /** @type {((inputs?: Seller_Dashboard_Stat_RevenueInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seller_Dashboard_Stat_RevenueInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_seller_dashboard_stat_revenue(inputs)
	if (locale === "es") return es_seller_dashboard_stat_revenue(inputs)
	if (locale === "fr") return fr_seller_dashboard_stat_revenue(inputs)
	if (locale === "de") return de_seller_dashboard_stat_revenue(inputs)
	if (locale === "ja") return ja_seller_dashboard_stat_revenue(inputs)
	if (locale === "zh") return zh_seller_dashboard_stat_revenue(inputs)
	if (locale === "ar") return ar_seller_dashboard_stat_revenue(inputs)
	if (locale === "id") return id_seller_dashboard_stat_revenue(inputs)
	if (locale === "it") return it_seller_dashboard_stat_revenue(inputs)
	if (locale === "ru") return ru_seller_dashboard_stat_revenue(inputs)
	if (locale === "pt") return pt_seller_dashboard_stat_revenue(inputs)
	return ko_seller_dashboard_stat_revenue(inputs)
});